import {NgModule} from '@angular/core';
import {NavbarComponent} from './navbar.component';
import {CommonModule} from '@angular/common';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap';
import {RouterModule} from '@angular/router';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
  declarations: [NavbarComponent],
  imports: [CommonModule, RouterModule, CollapseModule.forRoot(),BsDropdownModule.forRoot(),FormsModule, ReactiveFormsModule],
  providers: [],
  exports: [NavbarComponent],
})
export class NavbarModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/navigation/navbar.module.ts